import React from 'react';
import { Button, ButtonGroup, Flex } from '@chakra-ui/react';

const examples = [
  {
    label: 'Príklad 1',
    cnf: '(p ∨ ¬q) ∧ (¬p ∨ r)',
    dimacs: `p cnf 3 2\n1 -2 0\n-1 3 0`
  },
  {
    label: 'Príklad 2',
    cnf: '(x ∨ y) ∧ (¬y ∨ z) ∧ (¬x ∨ ¬z)',
    dimacs: `p cnf 3 3\n1 2 0\n-2 3 0\n-1 -3 0`
  },
  {
    label: 'Príklad 3',
    cnf: '(p ∨ q ∨ r) ∧ (¬p ∨ ¬q ∨ r) ∧ (¬p ∨ q ∨ ¬r) ∧ (p ∨ ¬q ∨ ¬r) ∧ (¬p ∨ ¬q ∨ ¬r)',
    dimacs: `p cnf 3 5\n1 2 3 0\n-1 -2 3 0\n-1 2 -3 0\n1 -2 -3 0\n-1 -2 -3 0`
  },
];

const ExampleFormulas = ({ isDimacs, onSelect }) => {
  return (
    <Flex justify="center" mb={3}>
      <ButtonGroup size="sm" spacing={5}>
        {examples.map((ex) => (
          <Button
            key={ex.label}
            onClick={() => {
              const formula = isDimacs ? ex.dimacs : ex.cnf;
              onSelect(formula);
            }}
            variant="outline"
          >
            {ex.label}
          </Button>
        ))}
      </ButtonGroup>
    </Flex>
  );
};

export default ExampleFormulas;
